/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_apex_help_combinations_desc = /** @type {(inputs: { count: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} possible team combinations were evaluated.`)
};

const es_f1_apex_help_combinations_desc = /** @type {(inputs: { count: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} combinaciones posibles de equipos fueron evaluadas.`)
};

const de_f1_apex_help_combinations_desc = /** @type {(inputs: { count: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} mögliche Teamkombinationen wurden bewertet.`)
};

const nl_f1_apex_help_combinations_desc = /** @type {(inputs: { count: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} mogelijke teamcombinaties zijn geëvalueerd.`)
};

const fr_f1_apex_help_combinations_desc = /** @type {(inputs: { count: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} combinaisons d’équipes possibles ont été évaluées.`)
};

const it_f1_apex_help_combinations_desc = /** @type {(inputs: { count: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} combinazioni possibili di team sono state valutate.`)
};

const pt_br2_f1_apex_help_combinations_desc = /** @type {(inputs: { count: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} combinações possíveis de equipes foram avaliadas.`)
};

const pt_f1_apex_help_combinations_desc = /** @type {(inputs: { count: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} combinações possíveis de equipas foram avaliadas.`)
};

const ja_f1_apex_help_combinations_desc = /** @type {(inputs: { count: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}通りのチームの組み合わせを評価しました。`)
};

const zh_f1_apex_help_combinations_desc = /** @type {(inputs: { count: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已评估${i?.count}种可能的车队组合。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_apex_help_combinations_desc = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_apex_help_combinations_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_apex_help_combinations_desc", locale)
	if (locale === "en") return en_f1_apex_help_combinations_desc(inputs)
	if (locale === "es") return es_f1_apex_help_combinations_desc(inputs)
	if (locale === "de") return de_f1_apex_help_combinations_desc(inputs)
	if (locale === "nl") return nl_f1_apex_help_combinations_desc(inputs)
	if (locale === "fr") return fr_f1_apex_help_combinations_desc(inputs)
	if (locale === "it") return it_f1_apex_help_combinations_desc(inputs)
	if (locale === "pt-BR") return pt_br2_f1_apex_help_combinations_desc(inputs)
	if (locale === "pt") return pt_f1_apex_help_combinations_desc(inputs)
	if (locale === "ja") return ja_f1_apex_help_combinations_desc(inputs)
	return zh_f1_apex_help_combinations_desc(inputs)
};